import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import get from 'lodash/get';

import * as checklistV2Actions from '../../../../actions/ChecklistV2Actions';

import * as checklistSelectors from '../../../../selectors/checklist/checklistSelectors';

import * as helpers from '../helpers';

import ChecklistTask from './ChecklistTask';

const mapStateToProps = (state, ownProps) => {
  const taskId = get(ownProps, 'params.id');
  const task = checklistSelectors.getChecklistTaskById(state, taskId);

  return {
    taskId,
    title: task.title,
    description: task.description,
    url: task.url,
    urlText: task.url_text,
    taskCompleted: Boolean(task.completed_at),
    isCustomTask: checklistSelectors.getIsCustomTask(state, taskId),
    sponsoredLink: task.sponsored_url,
    sponsoredLinkText: task.sponsored_url_text,
    isSponsoredLinkFromZola: !helpers.isSponsoredLink(task.sponsored_url),
    invitePartnerViewActive: checklistSelectors.getPartnerDropdownState(state),
  };
};

const mapDispatchToProps = dispatch => ({
  mobileCloseTask: () => dispatch(checklistV2Actions.handleMobileClose()),
  editCustomTask: (formValues, taskId) => dispatch(checklistV2Actions.editCustomTask(formValues, taskId)).then(() => dispatch(checklistV2Actions.emitConfMsg())),
  trackView: taskId => dispatch(checklistV2Actions.trackChecklistAction({ eventName: 'Task Viewed', taskId })),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ChecklistTask),
);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTask/index.js